import React, { useEffect, useState } from "react";
import { Select, MenuItem } from '@mui/material';
import { useCustomTheme } from "../../api/ThemeProvider";
import Card from '@mui/material/Card';
import { useDataProvider } from "../../api/DataProvider";
import { useCommProvider } from "../../api/CommProvider";
import { WebcamSelection } from "../home/WebcamSelection";
import "../../styles/devices/mob_UserProfile.css";
import { useTranslation } from "react-i18next";



export function DialogConfiguration(props) {

  const { toggleTheme, setToggleTheme } = useCustomTheme()
  const { token_id, currentUser, json_data_USER, set_json_data_USER } = useDataProvider();
  const { comm_updateDefaultPermission, comm_updateEmailPermission, comm_updateTheme, comm_updateSession } = useCommProvider();
  const [ selectedDefaultPermission, setSelectedDefaultPermission ] = useState("NONE");
  const [ selectedEmailPermission, setSelectedEmailPermission ] = useState("NONE");
  const { t } = useTranslation("global")
  
  /* Devices */
  const [deviceId, setDeviceId] = useState({});

  useEffect(() => {
    if (json_data_USER !== undefined && json_data_USER !== null){
      if (json_data_USER['default_permission'] !== undefined) {
        setSelectedDefaultPermission(json_data_USER['default_permission'])
      }
      if (json_data_USER['email_permission'] !== undefined) {
        setSelectedEmailPermission(json_data_USER['email_permission'])
      }
    }
  }, [json_data_USER])

  async function handleNightModeChange(event){
    setToggleTheme(event.target.checked)
    try{
      const response = await comm_updateSession(token_id, currentUser, {'theme': event.target.checked})
      set_json_data_USER({...json_data_USER, session: {...json_data_USER.session, theme: response['theme']}});
    }catch(err){
        console.error(err)
    }
  };

  async function handleDefaultPermissionChange(event){
    try{
      const response = await comm_updateDefaultPermission(token_id, currentUser, event.target.value)
      setSelectedDefaultPermission(event.target.value);
      set_json_data_USER({ ...json_data_USER, 'default_permission': response['default_permission'] });
    }catch(err){
        console.error(err)
    }
  };

  async function handleEmailPermissionChange(event){
    try{
      const response = await comm_updateEmailPermission(token_id, currentUser, event.target.value)
      setSelectedEmailPermission(event.target.value);
      set_json_data_USER({ ...json_data_USER, 'email_permission': response['email_permission'] });
    }catch(err){
        console.error(err)
    }
  };


  return (
    <>
      <Card>
        <div className='sig_ProfileInfo_Root'>
          <div className='sig_ProfileInfo_MainContainer'>
            <div className='sig_SignModal_PaperLine'>
              <div className="sig_SignModal_PaperTitle" htmlFor="nightModeSwitch"> {t("sProfile.config_nocturne")} </div>
              <div>
                <input
                  type="checkbox"
                  className="sig_ProfileModal_Input"
                  id="nightModeSwitch"
                  checked={toggleTheme}
                  onChange={handleNightModeChange}
                />
                <label className="sig_SignModal_PaperBody" htmlFor="nightModeSwitch">
                  {toggleTheme ? t("strButton.activated") : t("strButton.deactivated")}
                </label>
              </div>
            </div>

            <div className='sig_ProfileModal_Line'>
              <div className="sig_SignModal_PaperTitle"> {t("sProfile.config_default_permission")} </div>
              <div className="sig_Modal_SwitchSelectContainer custom-control custom-switch">
                <Select
                  className="sig_ProfileSettings_List"
                  id="selectedDefaultPermission"
                  value={selectedDefaultPermission}
                  size="small"
                  onChange={handleDefaultPermissionChange}
                >
                  <MenuItem className='sig_ProfileSettings_ListItem' value="VIDEO"> {t("sProfile.permission_video").toUpperCase()} </MenuItem>
                  <MenuItem className='sig_ProfileSettings_ListItem' value="KP"> {t("sProfile.permission_kps").toUpperCase()} </MenuItem>
                  <MenuItem className='sig_ProfileSettings_ListItem' value="NONE"> {t("sProfile.permission_none").toUpperCase()} </MenuItem>
                </Select>
              </div>
            </div>

            <div className='sig_ProfileModal_Line'>
              <div className="sig_SignModal_PaperTitle"> {t("sProfile.config_email")} </div>
              <div className="sig_Modal_SwitchSelectContainer custom-control custom-switch ">
                <Select 
                  className="sig_ProfileSettings_List"
                  id="selectedEmailPermission"
                  value={selectedEmailPermission}
                  size="small"
                  onChange={handleEmailPermissionChange}
                >
                  <MenuItem className='sig_ProfileSettings_ListItem' value="ALL"> {t("sProfile.permission_email_ALL")} </MenuItem>
                  <MenuItem className='sig_ProfileSettings_ListItem' value="IMPORTANT"> {t("sProfile.permission_email_IMPORTANT")} </MenuItem>
                  <MenuItem className='sig_ProfileSettings_ListItem' value="NONE"> {t("sProfile.permission_email_NONE")} </MenuItem>
                </Select>
              </div>
            </div>

            <div className='sig_ProfileModal_Line'>
              <div className="sig_SignModal_PaperTitle"> {t("sProfile.config_camera")} </div>
              <div className="sig_Modal_SwitchSelectContainer custom-control custom-switch">
                  <WebcamSelection deviceId={deviceId} setDeviceId={setDeviceId} userConfig={true}/>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
}

